import Backbone from "backbone-upstream";
import _ from "underscore";
import $ from "jquery";

Backbone.$ = $;

Backbone.View.prototype.floorPlan = null;
Backbone.View.prototype.unit = null;
Backbone.View.prototype.repeatForChildren = function(method, ...args) {
    if (this.children) {
        _.each(this.children, function(child) {
            if (child instanceof Backbone.View) {
                child[method](...args);
            }
        });
    }
};
Backbone.View.prototype.setFloorPlan = function(fp) {
    this.floorPlan = fp;
    this.repeatForChildren("setFloorPlan", fp);
};
Backbone.View.prototype.setUnit = function(unit) {
    this.unit = unit;
    this.repeatForChildren("setUnit", unit);
};

Backbone.View.prototype.renderSize = "lg";
Backbone.View.prototype.setRenderSize = function(size) {
    this.renderSize = size;
    this.repeatForChildren("setRenderSize", size);
};

export default Backbone
